module.exports = __webpack_public_path__ + "static/media/queue18.2f0e5925.svg";